import { render, staticRenderFns } from "./pageSettings.vue?vue&type=template&id=916d7200&scoped=true"
import script from "./pageSettings.vue?vue&type=script&lang=js"
export * from "./pageSettings.vue?vue&type=script&lang=js"
import style0 from "./pageSettings.vue?vue&type=style&index=0&id=916d7200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916d7200",
  null
  
)

export default component.exports